import { Box, Divider, Link, Typography } from "@mui/material";
import { linkStyling } from "../styles/styling";

// COMPONENTS
import Definition from "./Definition";

// SPEED LIMITS
export default function Definitions() {
    return (
        <Box component="section" id="definitions" display="flex" flexDirection="column" sx={{ mt: 5 }}>
            <Box>
                <Typography variant="h5" fontFamily="Public Sans" color="white" sx={{ mb: 2 }}>
                    <Link href="#definitions" sx={linkStyling}>#</Link> Definitions
                </Typography>
            </Box>

            <Box>
                <Definition title="Capital Crimes">
                    Any crime that is committed at the Capital level will require a hearing before a member of the Judiciary, prior to imposition of a sentence/fine. Defendants shall be held in Bolingbroke until the time of their trial/sentencing hearing, and are not to be released until after this has been completed. Due to the severity of these charges, Capital crimes have top priority in the legal system and must be dealt with within a 7-day period from the date of arrest.
                </Definition>

                <Definition title="Capital Murder Modifier">
                    <ul>
                        <li>The victim is a police officer, firefighter, paramedic, or similar government employee/official; and was killed whilst on duty.</li>
                        <li>The victim is killed during the commission of another violent felony, such as armed robbery, kidnaping, arson, etc.</li>
                        <li>The victim is tortured.</li>
                        <li>Multiple murders are committed pursuant to one another.</li>
                        <li>Murder-for-hire.</li>
                        <li>Death of a victim in the commission of a terrorist act.</li>
                        <li>The victim is a witness to a crime.</li>
                    </ul>
                </Definition>

                <Definition title="Racketeer Influenced and Corrupt Organisations Act">
                    The R.I.C.O Act covers crimes perpetrated by an employee who has committed, and successfully charged with, "multiple acts of racketeering activity" within a 6 month period, if such acts are related to the operation of a business in the name of a criminal entity, or with individual criminal interest regardless of monetary, reputational, or asset based gains.
                </Definition>

                <Definition title="Serious Injury">
                    'Serious Injury' is defined as Life threatening or Potentially Life threatening Harm or Permanent or Prolonged Disability or Significant Loss of Bodily Function or Severe Disfigurement or Prolonged Recovery Time or Risk of Complications - In the opinion of a registered Medical Professional (Doctor, Nurse or Paramedic).
                </Definition>

                <Definition title="Malice aforethought">
                    A mental state in which a person intends to kill someone else or commit an act that they know will endanger human life.
                </Definition>

                <Definition title="Violent Felony">
                    Any felony crime where violence was directly utilised in the perpetration of said crime. General threat of violence does not constitue a violent offence, however the use of any firearm in the commission of a predicate offence may still constitue an act of violence.
                </Definition>

                <Definition title="Illegal contraband">
                    Items that are restricted or are considered to be harmful, as described by the Department of Corrections.
                </Definition>

                <Definition title="Charge Modifiers & Reductions">
                    Where an individual is successfully charged as an Accessory or Accomplice to a crime that has been committed by a 3rd party, OR made an Attempt, then the following may apply to their charge handling:

                    <ul>
                        <li>Accessory - 50% reduction in both time and fine of the single charge of which this modifier applies to.</li>
                        <li>Accomplice - 25% reduction in the time relating to the single charge of which this modifier applies to.</li>
                        <li>Attempt - 50% reduction in both time and fine of the single charge of which this modifier applies to.</li>
                    </ul>

                    Appliable by Law Enforcement Officers and members of the Department of Justice.
                </Definition>

                <Definition title="Attempt">
                    A wilful effort to achieve or complete the commission of a crime.
                </Definition>

                <Definition title="Accomplice">
                    Direct assistance to the commission of a crime, but not directly in violation of the crime itself. Examples being a Primary Get-Away driver for a robbery, a distraction for Law Enforcement during the commission of a crime, or a "Look-out".
                    Should an accomplice utilise a firearm during the commission of the crime they are the accomplice of, they are subject to the suspension of said firearms license providing it is stated within the relevant charge they are associated with.
                </Definition>

                <Definition title="Accessory">
                    Willfully commissioned, assisted, or benefitted in any form, from any criminal activity without having direct input to the accused crime in question. Examples being Secondary/Tertiary Getaway driver's, Interference Vehicle driver, or "Hand-Off" individuals who take posession of illicit goods during an active pursuit.
                </Definition>

                <Definition title="51/50 Hold">
                    A 51/50 hold is a tool to be used by both Law Enforcement Agencies and Certified Medical Personnel alike. A 51/50 is defined as an individual who poses a direct threat to themselves or others by general neglect for personal life, abuse, or violence, due to a lowered state of mental health.
                    <br/>
                    <br/>
                    A 51/50 hold may be issued by LEO's, EMT's, or Certified Medical Staff, and can last up to a maximum of 3 days before the individual must be released, or the need for a 52/50 hold is required.
                </Definition>

                <Definition title="52/50 Hold">
                    A 52/50 hold is an extension of a 51/50 hold. It allows for a much longer detainment period for enhanced evaluation and crisis control for individuals who pose a threat to themselves, or others, due to a lowered state of mental health.
                    <br/>
                    <br/>
                    In order for a 52/50 hold to become active, it must first be presented to a Judge, where Certified Medical Staff provide a professional assessment of the individual, outlining required treatments, post-treatment action, and an outline of the individual's threat level to themselves and others. LEO's directly involved with the handling of the individual may provide statements on the individual's actions and lead-up to detainment, however the course of action relating to the 52/50 may only be provided by Certified Medical Staff.
                    <br/>
                    <br/>
                    A 52/50 hold may only be set for an initial period of 7 days, afterwhich a review is required in order to continue the hold. Failure to review shall lead to the immediate release of the individual in question.
                </Definition>

                <Definition title="Controlled Substance">
                    <ul>
                        <li>Schedule I: Ecstasy, Heroin, LSD, "Rocket Fuel", and Peyote</li>
                        <li>Schedule II: Methamphetamine, Cocaine, Fentanyl, Vicodin, Oxycodone, and Adderall</li>
                        <li>Schedule III: Marijuana, Anabolic Steroids, Testosterone, Psilocybin (Mushrooms), and Ketamine</li>
                        <li>Schedule IV: Xanax, Ambien, Ativan, Valium, and Tramadol</li>
                        <li>Schedule V: Cough suppressants</li>
                    </ul>

                    <b>Exceptions to Marijuana:</b>
                    <ul>
                        <li>Legal limit to carry is 1x baggie of weed, or 20 joints total.</li>
                        <li>The use of Medical Marijuana is authorized providing the individual has a valid prescription card from San Andreas Health Association.</li>
                        <li>The limit of Medical Marijuana is set to 2 prescribed amounts worth. The prescribed limit per individual is set by San Andreas Health Association.</li>
                    </ul>
                </Definition>

                <Definition title="Approved Hunting Hours">
                    Legal hours: 05:00 through 21:00.
                </Definition>

                <Definition title="Proper Vehicle Equipment">
                    <ul>
                        <li>Headlights</li>
                        <li>Tail Lights</li>
                        <li>Turn Signals</li>
                        <li>Visible Registration Plate</li>
                        <li>2 Rear Facing Mirrors</li>
                    </ul>
                    
                    <b>Motorcycles, when able:</b>
                    <ul>
                        <li>Visible Registration Plate</li>
                    </ul>

                    <Divider sx={{ my: 2 }} />
                    For motorcycle models that are not possible to display a plate, Motorcyclists must be able to provide proof of registration when questioned.
                </Definition>

                <Definition title="Firearms">
                    Firearms that are purchased legally through licensed vendors whilst using a valid Firearms License are considered legal firearms
                    <br />
                    <br />
                    The exception to this is stun guns as provided by the state to any private business as agreed with via the BBB. The Firearms License also covers the ability to conceal carry a firearm.
                    <br />
                    <br />
                    A firearms licence is automatically revoked after any violent felony. After a 30 day period, the individual may attend a local police station and attempt to pass a Firearm Handling review held by an LEO Supervisor or above.
                    <br />
                    <br />
                    Hunting licensing is stand-alone from general purpose firearm ownership, and may still allow the holder of said licence to continue to utilise hunting weapons to conduct legal hunting.
                </Definition>

                <Definition title="Controlled Items">
                    Items defined as limited access to the public but are agreed to be in the possession of licensed businesses as laid out by the BBB and the State. These include tasers, taser cartridges, and medium (level 2) armour.
                </Definition>

                <Definition title="Illegal Firearms">
                    <b>Class 1</b>
                    <ul>
                        <li>Stun Gun</li>
                        <li>Pistol .50</li>    
                    </ul>

                    <b>Class 2</b>
                    <ul>
                        <li>AP Pistol</li>
                        <li>MP9A Sub Machine Gun</li>
                        <li>Pump Shotgun</li>
                        <li>Beanbag Shotgun</li>
                        <li>Pump Shotgun Mk II</li>
                        <li>Heavy Shotgun</li>
                        <li>Bullpup Shotgun</li>
                        <li>Double-Barelled Shotgun</li>
                        <li>SMG</li>
                        <li>Micro SMG</li>
                        <li>Machine Pistol</li>
                        <li>Mini SMG</li>
                        <li>Gusenberg Sweeper</li>
                        <li>Combat PDW</li>
                    </ul>

                    <b>Class 3</b>
                    <ul>
                        <li>MK18 Combat Rifle</li>
                        <li>Tactical Rifle</li>
                        <li>Marksman Rifle</li>
                        <li>Sweeper Shotgun</li>
                        <li>Compact Rifle</li>
                        <li>Bullpup Rifle</li>
                        <li>Special Carbine Rifle</li>
                        <li>Special Carbine Rifle Mk II</li>
                        <li>Assault Rifle</li>
                        <li>Assault Rifle Mk II</li>
                        <li>Carbine Rifle</li>
                        <li>Carbine Rifle Mk II</li>
                        <li>Military Rifle</li>
                        <li>Heavy Rifle</li>
                    </ul>

                    <b>Class 5</b>
                    <ul>
                        <li>Railgun</li>
                        <li>Homing Launcher</li>
                        <li>RPG</li>
                        <li>Minigun</li>
                    </ul>
                </Definition>

                <Definition title="Illegal Weapon Modifications">
                    Suppressor/Silencer
                </Definition>

                <Definition title="Illegal Weapons">
                    <ul>
                        <li>Switchblade</li>
                        <li>Molotovs</li>
                        <li>Thermal Charges</li>
                        <li>Sticky Bomb</li>
                    </ul>
                </Definition>
            </Box>
        </Box>
    )
}
